import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useApi } from '@/functions/api'
import { useInitApp } from '@/models/init'
import { useAuthStore } from '@/stores/auth'

export function useAuthLogin () {
  const api = useApi()

  const { initApp } = useInitApp()

  const form = reactive({
    email: '',
    password: '',
    remember: false,
  })
  const submitting = ref(false)
  const errors = ref<FormError>({})

  const submit = async () => {
    try {
      submitting.value = true
      errors.value = {}
      await api.POST('auth/login', form)
      await initApp() // let init do the redirect to home
    } catch (error) {
      errors.value = api.formErrors(error)
      submitting.value = false
    }
  }

  return {
    form,
    submitting,
    errors,
    submit,
  }
}

export function useAuthLogout () {
  const api = useApi()
  const auth = useAuthStore()
  const router = useRouter()

  const submitting = ref(false)
  const logout = async () => {
    submitting.value = true
    api.POST('auth/logout')
    auth.$reset()
    auth.setAuthenticated(0)
    router.replace({ name: 'login' })
  }

  return {
    submitting,
    logout,
  }
}
